module.exports = __webpack_public_path__ + "static/media/3_15.b2ef343c.png";